import { useEffect, useState } from "react";
import { apiClient } from "../lib/api";
import { motion } from "framer-motion";
import { Trophy, Crown } from "lucide-react";

const RANK_COLOR = { Bronze:"#C58A4D", Silver:"#B7C6D2", Gold:"#F1C232", Platinum:"#5DE0E6", Diamond:"#88D8FF", Master:"#FF007F" };

export default function Leaderboard() {
  const [rows, setRows] = useState([]);
  useEffect(()=>{
    apiClient.get("/leaderboard?limit=100").then(r=>setRows(r.data.leaderboard)).catch(()=>{});
  },[]);
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-10 py-12">
      <div className="flex items-end justify-between mb-8">
        <div>
          <div className="font-mono text-[10px] tracking-[0.4em] text-cyan">GLOBAL LADDER</div>
          <h1 className="font-heading font-black text-3xl sm:text-4xl mt-2">TOP <span className="text-cyan">PLAYERS</span></h1>
        </div>
        <Trophy className="text-pink" size={28}/>
      </div>
      <div className="ba-card overflow-x-auto">
        {/* Desktop Header */}
        <div className="hidden sm:grid grid-cols-12 px-4 py-3 border-b border-white/5 font-mono text-sm tracking-[0.25em] text-zinc-500">
          <div className="col-span-1">#</div><div className="col-span-5">PLAYER</div><div className="col-span-2">RANK</div>
          <div className="col-span-2 text-right">MMR</div><div className="col-span-2 text-right">W / L</div>
        </div>
        {rows.length === 0 && <div className="p-8 text-center text-zinc-500" data-testid="empty-leaderboard">No players yet. Be the first.</div>}
        {rows.map((r, i) => (
          <motion.div key={r.username} initial={{opacity:0, x:-10}} animate={{opacity:1, x:0}} transition={{delay:i*0.02}}>
            {/* Desktop Row */}
            <div className="hidden sm:grid grid-cols-12 px-4 py-3 items-center border-b border-white/5 hover:bg-white/5 transition" data-testid={`leaderboard-row-${i}`}>
              <div className="col-span-1 font-mono font-bold text-cyan">{r.rank_pos===1 && <Crown size={16} className="inline text-pink mr-1"/>}{r.rank_pos}</div>
              <div className="col-span-5 font-heading font-bold">{r.username}</div>
              <div className="col-span-2 font-mono text-xs tracking-widest" style={{color: RANK_COLOR[r.rank] || "#fff"}}>{r.rank.toUpperCase()}</div>
              <div className="col-span-2 text-right font-mono text-cyan font-bold">{r.elo}</div>
              <div className="col-span-2 text-right font-mono text-zinc-400 text-sm">{r.wins}/{r.losses}</div>
            </div>
            
            {/* Mobile Row - Card style stacking */}
            <div className="sm:hidden p-4 border-b border-white/5 hover:bg-white/5 transition">
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                  <span className="font-mono font-bold text-cyan text-lg">{r.rank_pos===1 && <Crown size={14} className="inline text-pink mr-1"/>}#{r.rank_pos}</span>
                  <span className="font-heading font-bold text-base">{r.username}</span>
                </div>
                {r.rank_pos===1 && <Crown size={20} className="text-pink" />}
              </div>
              <div className="grid grid-cols-3 gap-3 text-sm">
                <div>
                  <div className="font-mono text-zinc-500 text-xs">Rank</div>
                  <div className="font-mono font-bold text-xs mt-1" style={{color: RANK_COLOR[r.rank] || "#fff"}}>{r.rank}</div>
                </div>
                <div>
                  <div className="font-mono text-zinc-500 text-xs">MMR</div>
                  <div className="font-mono text-cyan font-bold mt-1">{r.elo}</div>
                </div>
                <div>
                  <div className="font-mono text-zinc-500 text-xs">W/L</div>
                  <div className="font-mono text-zinc-400 mt-1">{r.wins}/{r.losses}</div>
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
